module.exports = __webpack_public_path__ + "img/greentick.3b720ad9.svg";